export default (props) => (
  <svg {...props} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        d="M17.842 8.083l-1.925-1.925a.099.099 0 010-.14l.99-.99a.1.1 0 01.14 0l1.926 1.924a.099.099 0 010 .14l-.99.99a.1.1 0 01-.14 0zM8.54 17.385L6.615 15.46a.099.099 0 010-.14l8.557-8.557a.1.1 0 01.14 0l1.925 1.925a.1.1 0 010 .14L8.68 17.385a.098.098 0 01-.14 0zm-1.174 1.288l-2.324.399a.1.1 0 01-.114-.114l.399-2.324a.097.097 0 01.027-.054l.52-.52a.099.099 0 01.14 0l1.926 1.925a.1.1 0 010 .14l-.52.52a.096.096 0 01-.054.028zM17.375 4.164a.561.561 0 00-.794 0l-1.923 1.924-8.708 8.707-1.276 1.276a.559.559 0 00-.156.301l-.51 2.972a.56.56 0 00.648.648l2.971-.51a.563.563 0 00.302-.156l.676-.676 9.892-9.891 1.339-1.34a.56.56 0 000-.793l-2.461-2.462z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
